import { ArrowLeft, FileCheck, Shield } from 'lucide-react';
import { getInlineViewerUrl } from '../utils/staticDocs';
import { ShareWhatsAppButton } from './ShareWhatsAppButton';

const DocViewerPage = ({ docKey }) => {
  const docs = {
    fdacs: {
      url: getInlineViewerUrl('fdacs_license'),
      title: 'Florida Seller of Travel Registration',
      subtitle: 'Licencia ST39568 — FDACS',
      badge: 'ACTIVA',
    },
    bond: {
      url: getInlineViewerUrl('surety_bond'),
      title: 'Florida Seller of Travel Surety Bond',
      subtitle: 'Cobertura $25,000 USD — TONS OF LEADS LLC',
      badge: 'VIGENTE',
    },
    'florida-certificate': {
      url: getInlineViewerUrl('florida_certificate_2026'),
      title: 'Florida Seller of Travel — Registration Certificate',
      subtitle: 'Certificado oficial 2026 — TONS OF LEADS LLC dba VIAJEMOS',
      badge: 'VIGENTE 2026',
    },
  };

  const doc = docs[docKey];
  if (!doc) return null;

  return (
    <div data-testid={`doc-viewer-${docKey}`} className="min-h-screen bg-slate-100 flex flex-col">
      <header className="bg-white border-b border-slate-200 sticky top-0 z-50">
        <div className="max-w-6xl mx-auto px-4 py-3 flex items-center gap-4">
          <a
            href="/licencias"
            data-testid="back-to-licencias"
            className="flex items-center gap-2 text-slate-500 hover:text-[#1D1D1B] font-medium text-sm transition-colors"
          >
            <ArrowLeft className="h-4 w-4" />
            Regresar a Licencias
          </a>
          <div className="w-px h-5 bg-slate-200" />
          <div className="flex items-center gap-2 flex-1 min-w-0">
            {docKey === 'fdacs' ? <FileCheck className="h-4 w-4 text-[#c9a227] flex-shrink-0" /> : <Shield className="h-4 w-4 text-[#c9a227] flex-shrink-0" />}
            <div className="min-w-0">
              <p className="font-bold text-[#1D1D1B] text-sm truncate">{doc.title}</p>
              <p className="text-slate-400 text-[10px] truncate">{doc.subtitle}</p>
            </div>
          </div>
          <ShareWhatsAppButton docKey={docKey} />
          <span className="bg-[#80C753]/15 text-[#80C753] text-[10px] font-bold px-2.5 py-1 rounded-full flex-shrink-0">{doc.badge}</span>
        </div>
      </header>

      <div className="flex-1">
        <iframe
          src={doc.url}
          className="w-full border-0"
          style={{ minHeight: 'calc(100vh - 56px)', height: 'calc(100vh - 56px)' }}
          title={doc.title}
        />
      </div>
    </div>
  );
};

export const FdacsViewerPage = () => <DocViewerPage docKey="fdacs" />;
export const BondViewerPage = () => <DocViewerPage docKey="bond" />;
export const FloridaCertificateViewerPage = () => <DocViewerPage docKey="florida-certificate" />;
export default DocViewerPage;
